module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harold Coyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Harold Coyle ")]), _vm._v("graduated from the Virginia Military Institute and spent fourteen years on active duty with the US Army.  He is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of nine novels, including "), _c('I', [_vm._v("The Ten Thousand, Team Yankee, God's Children ")]), _vm._v("and"), _c('I', [_vm._v(" Dead Hand")]), _vm._v(".  He lives in Leavenworth, Kansas.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SCOAg/tc-custom/9781466824904.jpg?1731883414874",
      "alt": "This image is the cover for the book God's Children, Nathan Dixon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("God's Children, Nathan Dixon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“The modern master of life-under-combat [delivers] an engrossing, uncompromisingly suspenseful tale” of high-tech warfare ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("As the Good Book says, “Blessed are the Peace Keepers, for they will be called God’s Children.” Yet for American soldiers deployed to warzones on foreign soil, peacekeeping is not child’s play. In this action-filled technothriller, author and military expert Harold Coyle examines some of the most pressing issues facing today’s soldiers."), _c('br'), _c('br'), _vm._v("When ethnic tensions in near-future Slovakia reach a boiling point, the US Army sends troops to join a NATO force in the region. "), _c('i', [_vm._v("God’s Children")]), _vm._v(" tells the story of 3rd Platoon, C Company, 2nd Battalion of the 13th Infantry, and two young officers who try to keep a peace that is falling apart before their very eyes.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0